export const getSizeClass = (size) => {
	return size === 's' ? 'modal-gutters-s' :
		   size === 'm' ? 'modal-gutters-m' :
		   size === 'l' ? 'modal-gutters-l' :
		   size === 'full' ? 'modal-gutters-full' :
		   'modal-gutters-full';
};